import { FaqItemProps } from 'common/components/entities/Faq/FaqItem'
import { showFaqIconCss } from 'common/utils/styleUtilsNew'
import { Prettify } from 'src/shared/types/typescript-utils/prettify'
import styled, { css } from 'styled-components'

type FaqItemArrowUiProps = Prettify<
  Pick<
    FaqItemProps,
    | 'expanded'
    | 'iconColor'
    | 'mobileIconColor'
    | 'showIcons'
    | 'mobileShowIcons'
  > & {
    hasClosedIcon: boolean
  }
>

const FaqItemArrowUi = styled.i<FaqItemArrowUiProps>`
  color: ${p => p.iconColor};
  transform: ${p =>
    !p.expanded || p.hasClosedIcon ? 'none' : 'rotate(180deg)'};
  transition: transform 0.3s;

  ${showFaqIconCss}
  ${p => p.theme.phone} {
    ${p => p.mobileIconColor && `color: ${p.mobileIconColor};`}
  }
  ${p =>
    p.theme.isEditorMobileMode &&
    css`
      ${p.mobileIconColor && `color: ${p.mobileIconColor};`}
    `}
`

export default FaqItemArrowUi
